module.exports = __webpack_public_path__ + "img/onboarding/add-cta-12b396a9d9cf9d9b8166c45116825edb.svg";